import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { SearchPoItemModel } from "../../../model/builk/po-item/search-poitem.model";
import { PoItemListModel } from "../../../model/builk/po-item/poitem-list.model";
import { PoItemDetailModel } from "../../../model/builk/po-item/poitem-detail.model";

@Injectable({
    providedIn: "root"
  })
export class PoItemService {

    constructor(
        private http: HttpClient
    ) { }

    sub: any;

    // get userlist (sort,search,filter)
    getPoItemBackOffice(searchPoItemModel: SearchPoItemModel): Observable<PoItemListModel> {

        const url = apiLink.getPoItemBackOffice;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<PoItemListModel>(url, searchPoItemModel, { headers });
    }

    getPoItemDetailBackOffice(poSurrKey: number): Observable<PoItemDetailModel> {
        const url = apiLink.getPoItemDetailBackOffice;
        const params = new HttpParams().set("poSurrKey", poSurrKey.toString());
        this.sub = this.http.get(url, { params });

        return this.sub;
    }
}
